module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/UG-8d6a130fdc9f16edd457de653375ab69.png";